// extracted by mini-css-extract-plugin
export default {"hover-only":"_33qrB","hoverOnly":"_33qrB","hover-only-and-collapsed":"_1i3hb","hoverOnlyAndCollapsed":"_1i3hb","hoverable":"rL8r5","permanent-icon":"_1VfTj","permanentIcon":"_1VfTj"};